import { render, staticRenderFns } from "./CardRepresentante.vue?vue&type=template&id=2674d88c&"
import script from "./CardRepresentante.vue?vue&type=script&lang=ts&"
export * from "./CardRepresentante.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports